module.exports = __webpack_public_path__ + "img/dundar-logo.4ca0ff33.png";